module.exports = "/images/clock.svg?30f526b106180ce9b92e015b6064aad8";